import { render, staticRenderFns } from "./HeaderMarket.vue?vue&type=template&id=b6688988&"
import script from "./HeaderMarket.vue?vue&type=script&lang=js&"
export * from "./HeaderMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports